import setOnInputTransducers from './set-on-input-transducers';

export default setOnInputTransducers;
